import { Component } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'update-phone-number-modal',
    template: `
        <div>
            <p class="body">
                We’ve noticed you used a single-use backup code to sign into your account. If you
                have changed your mobile device or phone number recently (ending in
                <span [style.fontWeight]="700">{{ phoneNumberLastFour }}</span
                >), please click the button below to update your multi-factor authentication
                settings. If your phone number has not changed please disregard this message.
            </p>
        </div>
    `
})
export class UpdatePhoneNumberModalComponent {
    public phoneNumberLastFour: string;

    constructor(private _modalService: ModalService) {
        this.phoneNumberLastFour = this._modalService.modal.data.phoneNumberLastFour;
    }
}
